import styled from 'styled-components';

export const Page = styled.div``;

export const Hero = styled.section`
  background: linear-gradient(
    120deg,
    ${({ theme }) => theme.colors.green[800]} 0%,
    ${({ theme }) => theme.colors.green[600]} 60%,
    ${({ theme }) => theme.colors.green[500]} 100%
  );
  color: #ffffff;
  padding: 48px 16px 40px;
`;

export const HeroContent = styled.div`
  max-width: ${({ theme }) => theme.container};
  margin: 0 auto;
  display: grid;
  gap: 16px;

  h1 {
    margin: 0;
    font-size: 2.4rem;
  }

  p {
    margin: 0;
    font-size: 1.05rem;
    line-height: 1.7;
    color: #f9fafb;
    max-width: 760px;
  }
`;

export const HeroTag = styled.span`
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 0.78rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const HeroHighlights = styled.ul`
  margin: 0;
  padding-left: 18px;
  display: grid;
  gap: 6px;
  max-width: 720px;
  line-height: 1.6;
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 32px auto 0;
  padding: 0 16px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 12px;
  color: ${({ theme }) => theme.colors.green[700]};
`;

export const SectionText = styled.p`
  margin: 0 0 12px;
  color: ${({ theme }) => theme.colors.gray[700]};
  line-height: 1.7;
`;

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 14px;
  padding: 18px;
  box-shadow: ${({ theme }) => theme.shadows.sm};

  h3 {
    margin: 0 0 8px;
    color: ${({ theme }) => theme.colors.green[700]};
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.gray[700]};
    line-height: 1.6;
  }
`;

export const List = styled.ul`
  margin: 8px 0 0;
  padding-left: 18px;
  color: ${({ theme }) => theme.colors.gray[700]};
  line-height: 1.7;
`;

export const Callout = styled.div`
  margin-top: 16px;
  background: ${({ theme }) => theme.colors.gray[100]};
  border-radius: 14px;
  padding: 18px;
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  display: grid;
  gap: 8px;

  a {
    color: ${({ theme }) => theme.colors.green[700]};
    font-weight: 600;
    text-decoration: none;
  }
`;
